<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Current Affair' : 'Add Current Affair'"
>
</nz-page-header>
<form nz-form [formGroup]="addUpdateCurrentAffairForm">
  <nz-card nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="subjectName" nzRequired
            >Title</nz-form-label
          >
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <input
              nz-input
              formControlName="title"
              type="text"
              placeholder="Enter Title "
            />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="titleName"
            >Title In Hindi</nz-form-label
          >
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <input
              nz-input
              formControlName="titleInHindi"
              type="text"
              placeholder="Enter Title "
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="exam-category"
            >Tags
          </nz-form-label>
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <nz-select
              [nzLoading]="tagLoading"
              (nzOnSearch)="onSearch($event)"
              nzServerSearch
              (nzScrollToBottom)="loadMore()"
              [nzMaxMultipleCount]="3"
              nzPlaceHolder="Please select Tags"
              formControlName="tags"
              nzMode="multiple"
              [nzDropdownRender]="renderTemplate"
            >
              <nz-option
                *ngFor="let item of listOfTags"
                [nzLabel]="item.name"
                [nzValue]="item.name"
                nzCustomContent
              >
                <div class="option-row">
                  <span>{{ item.name }}</span>

                  <!-- DELETE only if NOT selected -->
                  <span
                    *ngIf="!isSelected(item.name)"
                    nz-popconfirm
                    nzPopconfirmTitle="
        Are you sure you want to delete this tag?
        This will remove it from all assigned
        current affairs and editorials.
      "
                    nzOkText="Yes"
                    nzCancelText="No"
                    (nzOnConfirm)="removeTag(item.name)"
                    (click)="$event.stopPropagation()"
                    class="delete-icon"
                  >
                    <span nz-icon nzType="delete"></span>
                  </span>
                </div>
              </nz-option>
            </nz-select>

            <ng-template #renderTemplate>
              <nz-divider></nz-divider>
              <div class="add-tag-row">
                <input nz-input placeholder="Add new tag" #inputElement />

                <button
                  [nzLoading]="tagLoading"
                  nz-button
                  nzType="primary"
                  nzGhost
                  (click)="addTag(inputElement)"
                >
                  <span nz-icon nzType="plus"></span>
                  Add
                </button>
              </div>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="exam-category"
            >Published Date
          </nz-form-label>
          <nz-form-control>
            <nz-date-picker
              class="width-100"
              formControlName="publishedDate"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <!-- <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="shortDescription"
            >Short Description</nz-form-label
          >
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <ngx-suneditor
              [editorID]="'shortDescription'"
              (onChange)="onShortDescriptionChange($event)"
              [options]="editorOptions"
            >
            </ngx-suneditor>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="shortDescriptionInHindi"
            >Short Description In Hindi</nz-form-label
          >
          <nz-form-control [nzSpan]="24">
            <ngx-suneditor
              [editorID]="'shortDescriptionInHindi'"
              (onChange)="onShortDescriptionHindiChange($event)"
              [options]="editorOptions"
            >
            </ngx-suneditor>
          </nz-form-control>
        </nz-form-item>
      </div> -->

      <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <nz-form-label [nzSpan]="24" nzRequired nzFor="description"
              >Description</nz-form-label
            >
            <ngx-suneditor
              [editorID]="'description'"
              (onChange)="onDescriptionChange($event)"
              [options]="editorOptions"
            >
            </ngx-suneditor>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="18" nzMd="18" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <nz-form-label [nzSpan]="24" nzFor="description"
              >Description In Hindi</nz-form-label
            >
            <ngx-suneditor
              (onChange)="onDescriptionHindiChange($event)"
              [editorID]="'descriptionInHindi'"
              [options]="editorOptions"
            >
            </ngx-suneditor>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="subject"
            >Image ( 1000px * 500px )</nz-form-label
          >
          <nz-upload
            class="upload-list-inline"
            nzName="avatar"
            (nzChange)="UploadImageFile($event, 'image', 0)"
            [nzName]="'file'"
            [nzShowUploadList]="false"
            [nzBeforeUpload]="beforeRelatedMediaUpload"
            [nzAction]="mediaUploadUrl"
            [nzHeaders]="customRequestHeaders"
          >
            <button
              nz-button
              *ngIf="!addUpdateCurrentAffairForm.value.image"
              [nzLoading]="imageLoading"
            >
              <span nz-icon nzType="upload"></span>
              Upload
            </button>
          </nz-upload>
          <div
            class="image-preview-card"
            *ngIf="addUpdateCurrentAffairForm.value.image"
          >
            <div class="image-preview-wrapper">
              <img
                nz-image
                class="image-preview-img"
                [nzSrc]="mediaBaseUrl + addUpdateCurrentAffairForm.value.image"
              />
            </div>
            <div class="image-action-row">
              <a
                nz-button
                nzType="text"
                nzTooltipTitle="Download"
                nz-tooltip
                [href]="mediaBaseUrl + addUpdateCurrentAffairForm.value.image"
                target="_blank"
                download
                class="image-action-btn image-action-download"
              >
                <span nz-icon nzType="download"></span>
              </a>
              <button
                nz-button
                nzType="text"
                nzDanger
                nzTooltipTitle="Delete"
                nz-tooltip
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to delete this image?"
                (nzOnConfirm)="
                  removeImage(addUpdateCurrentAffairForm.value.image)
                "
                class="image-action-btn image-action-delete"
              >
                <span nz-icon nzType="delete"></span>
              </button>
            </div>
          </div>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <button
        nz-button
        nzType="primary"
        [nzLoading]="buttonLoading"
        (click)="submit()"
        class="submitoraddbutton"
      >
        {{ idForUpdate ? "Update" : "Submit" }}
      </button>
    </div>
  </nz-card>
</form>
